module.exports = __webpack_public_path__ + "static/media/user-male-icon.6df4521c.png";